import { render, staticRenderFns } from "./VChatMessage.vue?vue&type=template&id=346f1446&"
import script from "./VChatMessage.vue?vue&type=script&lang=ts&"
export * from "./VChatMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports